import { connect } from 'react-redux';

import { IState } from '../../../store';
import { ISharingButtonProps, SharingButton } from './index';
import { shareTitleSelector } from '../../../selectors/shareTitleSelector';

function mapStateToProps(state: IState): ISharingButtonProps {
  return {
    offerData: state.offerData,
    pageData: state.pageData,
    title: shareTitleSelector(state, true),
  };
}

export const SharingButtonContainer = connect<ISharingButtonProps, {}>(mapStateToProps)(SharingButton);
